import { render, staticRenderFns } from "./RedecoForm.vue?vue&type=template&id=156545c0&"
import script from "./RedecoForm.vue?vue&type=script&lang=js&"
export * from "./RedecoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports